var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductServiceTitleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 29.8337H19.9998C26.6665 29.8337 29.3332 27.167 29.3332 20.5003V12.5003C29.3332 5.83366 26.6665 3.16699 19.9998 3.16699H11.9998C5.33317 3.16699 2.6665 5.83366 2.6665 12.5003V20.5003C2.6665 27.167 5.33317 29.8337 11.9998 29.8337Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 25.1663C22.1333 25.1663 23.3333 23.9663 23.3333 22.4997V10.4997C23.3333 9.03301 22.1333 7.83301 20.6667 7.83301C19.2 7.83301 18 9.03301 18 10.4997V22.4997C18 23.9663 19.1867 25.1663 20.6667 25.1663Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 25.167C12.7998 25.167 13.9998 23.967 13.9998 22.5003V17.8337C13.9998 16.367 12.7998 15.167 11.3332 15.167C9.8665 15.167 8.6665 16.367 8.6665 17.8337V22.5003C8.6665 23.967 9.85317 25.167 11.3332 25.167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductServiceTitleIcon);
export default __webpack_public_path__ + "static/media/product-service-title-icon.1b491a1a95f38862c44643e05faa825b.svg";
export { ForwardRef as ReactComponent };